import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  ENGINE_CARDS,
  MODULE_CHIPS,
  NO_BLOAT_ITEMS,
  PITCH_PILLS,
} from '../../data/walkthrough.fixtures';

/**
 * Pane 1 / 8 — `The whole platform, one page` (specs/auth.md §5.4).
 *
 * ---------------------------------------------------------------------------
 * THE PANE THAT PROVES THE FRAME IS RIGHT, BY NOT FITTING IT.
 *
 * Every other pane is copy beside an illustration. This one has no copy/viz
 * split, no bullet list, and a primary ground running edge to edge — six
 * stacked blocks that are a landing page rather than a slide. It is the reason
 * `walkthrough-slide` has no `variant` input: a body that will not fit the slot
 * means the frame is wrong FOR THAT BODY, not that the frame needs an option
 * (D10, D31.3).
 * ---------------------------------------------------------------------------
 *
 * Three of its blocks reflow, each at a different width and each through the
 * shared map: the engine pair at `pane-engine` (620), the call-out's three
 * items at `pane-cards` (760), and the whole block's padding at `pane-nav`
 * (700). The module strip uses `auto-fill` and so reflows continuously — the
 * only grid in the feature that does.
 *
 * ⚠ The 14 module chips are a PICTURE of the catalogue, not the catalogue
 * (§12 #16). No click, no route, no capability key.
 */
@Component({
  selector: 'app-walkthrough-pane1',
  standalone: false,
  templateUrl: './walkthrough-pane1.component.html',
  styleUrls: ['./walkthrough-pane1.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane1Component {
  readonly engines = ENGINE_CARDS;
  readonly modules = MODULE_CHIPS;
  readonly noBloat = NO_BLOAT_ITEMS;
  readonly pills = PITCH_PILLS;
}
